import React, { useState } from "react";
import "./Bicycle.css";
import { Link } from "react-router-dom";
/* Image Imports */

import HeroSprint from "../../assets/HeroSprint.png";
import AtlasUltimate from "../../assets/AtlasUltimate.png";
import HerculesRoadeo from "../../assets/HerculesRoadeo.png";
import FirefoxBadAttitude from "../../assets/FirefoxBadAttitude.png";
import BtwinRockrider from "../../assets/BtwinRockrider.png";
import MontraTrance from "../../assets/MontraTrance.png";
import GiantEscape3 from "../../assets/GiantEscape3.png";
import TrekFX1 from "../../assets/TrekFX1.png";
import SchwinnDiscover from "../../assets/SchwinnDiscover.png";
import UrbanTerrainUT1000 from "../../assets/UrbanTerrainUT1000.png";
import NinetyOneSnowLeopard from "../../assets/NinetyOneSnowLeopard.png";
import LeaderBeast from "../../assets/LeaderBeast.png";

import HeroLectroC3 from "../../assets/HeroLectroC3.png";
import HeroLectroF6i from "../../assets/HeroLectroF6i.png";
import EMotoradTrekX from "../../assets/EMotoradTrekX.png";
import EMotoradX2 from "../../assets/EMotoradX2.png";
import NexzuRoadlark from "../../assets/NexzuRoadlark.png";

import ToutcheHeileoH100 from "../../assets/ToutcheHeileoH100.png";
import ToutcheHeileoM100 from "../../assets/ToutcheHeileoM100.png";
import GiantExploreE from "../../assets/GiantExploreE.png";
import TrekVervePlus from "../../assets/TrekVervePlus.png";
import AvonEPlus from "../../assets/AvonEPlus.png";
import LightspeedGlider from "../../assets/LightspeedGlider.png";

const bicycleData = [
  /* Manual Bicycles */

  {
    id: 1,
    name: "Hero Sprint",
    capacity: "1 Person",
    type: "Manual",
    price: 40,
    image: HeroSprint,
  },
  {
    id: 2,
    name: "Atlas Ultimate",
    capacity: "1 Person",
    type: "Manual",
    price:  35,
    image: AtlasUltimate,
  },
  {
    id: 3,
    name: "Hercules Roadeo",
    capacity: "1 Person",
    type: "Manual",
    price: 45,
    image: HerculesRoadeo,
  },
  {
    id: 4,
    name: "Firefox Bad Attitude",
    capacity: "1 Person",
    type: "Manual",
    price: 50,
    image: FirefoxBadAttitude,
  },
  {
    id: 5,
    name: "Btwin Rockrider",
    capacity: "1 Person",
    type: "Manual",
    price: 45,
    image: BtwinRockrider,
  },
  {
    id: 6,
    name: "Montra Trance",
    capacity: "1 Person",
    type: "Manual",
    price: 48,
    image: MontraTrance,
  },
  {
    id: 7,
    name: "Giant Escape 3",
    capacity: "1 Person",
    type: "Manual",
    price: 55,
    image: GiantEscape3,
  },
  {
    id: 8,
    name: "Trek FX 1",
    capacity: "1 Person",
    type: "Manual",
    price: 60,
    image: TrekFX1,
  },
  {
    id: 9,
    name: "Schwinn Discover",
    capacity: "1 Person",
    type: "Manual",
    price: 50,
    image: SchwinnDiscover,
  },
  {
    id: 10,
    name: "Urban Terrain UT1000",
    capacity: "1 Person",
    type: "Manual",
    price:40,
    image: UrbanTerrainUT1000,
  },
  {
    id: 11,
    name: "Ninety One Snow Leopard",
    capacity: "1 Person",
    type: "Manual",
    price: 42,
    image: NinetyOneSnowLeopard,
  },
  {
    id: 12,
    name: "Leader Beast",
    capacity: "1 Person",
    type: "Manual",
    price: 38,
    image: LeaderBeast,
  },

  /* Electric Bicycles */

  {
    id: 13,
    name: "Hero Lectro C3",
    capacity: "1 Person",
    type: "Electric",
    price: 90,
    image: HeroLectroC3,
  },
  {
    id: 14,
    name: "Hero Lectro F6i",
    capacity: "1 Person",
    type: "Electric",
    price: 95,
    image: HeroLectroF6i,
  },
  {
    id: 15,
    name: "EMotorad Trek X",
    capacity: "1 Person",
    type: "Electric",
    price: 100,
    image: EMotoradTrekX,
  },
  {
    id: 16,
    name: "EMotorad X2",
    capacity: "1 Person",
    type: "Electric",
    price: 95,
    image: EMotoradX2,
  },
  {
    id: 17,
    name: "Nexzu Roadlark",
    capacity: "1 Person",
    type: "Electric",
    price: 90,
    image: NexzuRoadlark,
  },

  {
    id: 18,
    name: "Toutche Heileo H100",
    capacity: "1 Person",
    type: "Electric",
    price: 105,
    image: ToutcheHeileoH100,
  },
  {
    id: 19,
    name: "Toutche Heileo M100",
    capacity: "1 Person",
    type: "Electric",
    price: 110,
    image: ToutcheHeileoM100,
  },
  {
    id: 20,
    name: "Giant Explore E",
    capacity: "1 Person",
    type: "Electric",
    price: 120,
    image: GiantExploreE,
  },
  {
    id: 21,
    name: "Trek Verve Plus",
    capacity: "1 Person",
    type: "Electric",
    price: 125,
    image: TrekVervePlus,
  },
  {
    id: 22,
    name: "Avon E Plus",
    capacity: "1 Person",
    type: "Electric",
    price: 85,
    image: AvonEPlus,
  },
  {
    id: 23,
    name: "Lightspeed Glider",
    capacity: "1 Person",
    type: "Electric",
    price: 90,
    image: LightspeedGlider,
  },
];

function Bicycle() {
  const [filter, setFilter] = useState("Manual");

  const filteredBikes = bicycleData.filter((bike) => bike.type === filter);

  return (
    <div className="bicycle-container">
      <div className="bike-buttons">
        <button className="manual-btn" onClick={() => setFilter("Manual")}>
          Manual Bicycle
        </button>

        <button className="electric-btn" onClick={() => setFilter("Electric")}>
          Electric Bicycle
        </button>
      </div>

      <div className="bike-grid">
        {filteredBikes.map((bikee) => (
          <Link
            to="/bicycle-rental-detail-page-data"
            className="scooter-ride-link"
            state={{
              bicycleData: bikee, // ✅ correct key
              totalPrice: bikee.price,
            }}
            key={bikee.id}
          >
            {" "}
            <div className="bike-card" key={bikee.id}>
              <span className="fuel-tag">{bikee.type}</span>
              <span className="price-tag">₹{bikee.price}</span>

              <div className="bicycle-image-div">
                {" "}
                <img src={bikee.image} alt={bikee.name} />
              </div>

              <h3>{bikee.name}</h3>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Bicycle;
